<script>
import SiteHeader from './components/SiteHeader.vue';
import Footer from './components/Footer.vue';



export default {
  name: 'App',
  components: {
    SiteHeader,
    Footer
  }
}
</script>

<template>
  <SiteHeader />
  <router-view />
  <Footer  />

</template>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
